import { removeFN } from '@pressreader/utils';

import { HistoryState, Location, State, To } from '../../types';
import { createEntryKey, createHref, createKey, parsePath } from '../../utils';

/**
 * Build the next Location from a navigation target, merged over the current
 * window.location. Shared by every backend — only how the result is persisted
 * differs (History API entry vs. hash fragment vs. in-memory stack). The hash is
 * dropped unless the target itself carries one: browser mode keeps generated
 * entries clean, and hash mode derives its fragment from the resulting href.
 *
 * Backends pass the current entry's `entryKey` on replace (same entry, new content)
 * and omit it on push, so a fresh entry gets a fresh identity.
 */
export function getNextLocation(to: To, state: State = {}, entryKey?: string): Location {
    const { pathname, href } = window.location;

    return {
        pathname,
        href,
        hash: '',
        search: '',
        ...(typeof to === 'string' ? parsePath(to) : to),
        state,
        key: createKey(),
        entryKey: entryKey ?? createEntryKey(),
    };
}

export function getHistoryStateAndUrl(nextLocation: Location): [HistoryState, string] {
    return [
        {
            state: removeFN(nextLocation.state),
            key: nextLocation.key,
            entryKey: nextLocation.entryKey,
        },
        createHref(nextLocation),
    ];
}
